import VBtn from './VBtn'
import VBtnToggle from './VBtnToggle'
import VSpeedDial from './VSpeedDial'

export default {
  VBtn,
  VBtnToggle,
  VSpeedDial
}



// WEBPACK FOOTER //
// ./src/components/buttons/index.js